<template>
    <div class="seat-container">
        <div class="seat-id is-inline-block is-size-7" v-if="noSeat">
            &nbsp;
        </div>

        <b-tooltip v-else-if="isSelectable"
            :label="characteristics"
            type="is-light"
            :position="orientation"
            multilined>

            <div @click="selectSeat()" class="seat-id is-inline-block is-size-7 selectableSeat" :class="isSelectableStyleClass" :style="isSelected">
            {{ seat.id }}
        </div>
        </b-tooltip>

        <!-- <b-tooltip v-else-if="!isSelectable"
            :label="characteristics"
            type="is-light"
            :position="orientation"
            multilined> -->

            <div v-else-if="!isSelectable" class="seat-id is-inline-block is-size-7"  :class="isSelectableStyleClass">
                <b-icon icon="close" size="is-small">
            </b-icon>
            </div>
        <!-- </b-tooltip> -->


        <!--<div class="occupation tag" :class="occupationStyleClass" v-if="seat.occupation">
            {{ occupationLabel }}
        </div>

        <b-taglist class="mt-3" v-if="seat.characteristics && !isOccupied">
			<b-tag v-for="characteristic in seat.characteristics" :key="characteristic">
				{{ characteristic.text }}
			</b-tag>
		</b-taglist>-->

        <div class="price tag" v-if="seat.price && isSelectable">
            <span v-if="seat.price.total > 0">
                {{ seat.price.total }}
            </span>
            <span v-else>
                $
            </span>
            
        </div>
    </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    seat: Object,
    orientation: String,
    isSelected: {},
  },
  data(){
    return {
      seats: [],
    }
  },
  computed: {
    occupationLabel() {
      return this.seat.occupation.text ?? ''
    },
    /* occupationStyleClass() {
      let styleClass;
      switch (this.seat.occupation.code) {
          case 'F':
              styleClass = 'is-free'
              break;
          case 'O':
              styleClass = 'is-occupied'
              break;
          case 'Z':
              styleClass = 'is-occupied'
              break;
          default:
              styleClass = ''
              break;
      }

      return styleClass;
    }, */
    isSelectable() {
      return this.seat.isSelectable
    },
    isSelectableStyleClass() {
      if (this.isSelectable) {
        return 'is-free'
      }

      return 'is-unavailable'
    },
    /* isAvailable() {
        return this.seat.occupation.code == 'F' && this.seatExists
    },
    notAvailable() {
        return this.isOccupied || this.noSeat
    }, */
    isOccupied() {
      return this.seat.occupation.code == 'O' || this.seat.occupation.code == 'Z'
    },
    seatExists() {
      return !this.noSeat
    },
    noSeat() {
      let matched = this.seat.characteristics.find((char) => {
        return char.code == '8' // no seat at this location
      })

      return matched
    },
    characteristics() {
      let messageParts = []

      if (this.seat.commercialName) {
        messageParts.push(this.seat.commercialName)
      }

      if (this.isOccupied || this.seat.characteristics.length == 0) {
        messageParts.push(this.seat.occupation.text)
      }
      else if (!this.seat.characteristics[0].text){
        messageParts.push(this.seat.occupation.text)
      }
      else {
        this.seat.characteristics.forEach((char) => {
          if (isNaN(char.text)){
            messageParts.push(char.text)
          }
          // messageParts.push(char.text)
        })
      }

      let message = messageParts.join(', ')

      return message
    },
  },
  methods: {
    selectSeat(){
      this.seat.characteristicsDisplay = this.characteristics.split(', ')
      this.seats.forEach(seat => {
        this.resetStyle(seat);
      });
      this.$emit('selected', this.seat)
    },
    resetStyle(node){
      node.style.background = 'none';
      node.style.color = '#777';
    },
  },
  mounted() {
    this.seats = document.querySelectorAll('.selectableSeat');
    this.seats.forEach(seat => {
      this.resetStyle(seat);
    });
  }
}

</script>

<style scoped>

.seat-container {
    position: relative;
    margin: 5px;
}

.price {
    position: absolute;
    top: -7px;
    right: 0px;
    background: green;
    color: white;
    line-height: 1rem;
    height: 1rem;
    padding: .2rem;

}

.seat-id.is-free {
    background: white;
    border: 1px solid #679fbf;
    cursor: pointer;
}

.seat-id.is-occupied {
    background: #eee;
    color: #bbb;
    border: 1px solid #ddd;
}

.seat-id.is-unavailable {
    background: #eee;
    color: #bbb;;
}

.occupation.is-free {
    background: green;
    color: white;
}

@media screen and (max-width: 1023px) {
  .seat-id {
      padding: 2px;
      border-radius: 10px;
      min-width: 30px;
      min-height: 30px;
      line-height: 20px;
      text-align: center;
      background: #fff;
  }
}

@media screen and (min-width: 1024px) {
  .seat-id {
      padding: 5px;
      border-radius: 5px;
      min-width: 40px;
      min-height: 30px;
      line-height: 20px;
      text-align: center;
      background: #fff;
  }
}

</style>
